/* eslint-disable */
import React from 'react';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const calorieTracking = useStore((state) => state.calorieTracking);
  const setCalorieTracking = useStore((state) => state.setCalorieTracking);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.calorieTracking.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={calorieTracking}
          onChange={(value) => {
            setCalorieTracking(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'calorie-tracking',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'yesWhile'}>
            <span>✅</span> {t('onboarding.calorieTracking.options.yesWhile')}
          </Option>
          <Option value={'stillSometimes'}>
            <span>🔢</span> {t('onboarding.calorieTracking.options.stillSometimes')}
          </Option>
          <Option value={'neverTried'}>
            <span>🙅‍♀️</span> {t('onboarding.calorieTracking.options.neverTried')}
          </Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
